import axios from 'axios';
import router from '../Router/index';

export default {
  namespaced: true,

  state: {
    callendars: {}
  },

  getters: {},

  mutations: {
    SET_CALLENDARS(state, value) {
      state.callendars = value;
    }
  },

  actions: {}
};
